














import { Component, Vue, Prop, Emit } from 'vue-property-decorator'

@Component
export default class AppSwitch extends Vue {
    @Prop() readonly options!: string[]
    @Prop() readonly selected!: string

    @Emit()
    optionSelected (option: string) {
      return option
    }
}

